import { render, staticRenderFns } from "./Feng.vue?vue&type=template&id=2459e338&scoped=true"
import script from "./Feng.vue?vue&type=script&lang=js"
export * from "./Feng.vue?vue&type=script&lang=js"
import style0 from "./Feng.vue?vue&type=style&index=0&id=2459e338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2459e338",
  null
  
)

export default component.exports